<div [formGroup]="locForm">
  <mat-slide-toggle formControlName="locationFiltersEnabled" color="primary">
    <label class="form-label">Apply location filters</label>
  </mat-slide-toggle>

  <div [hidden]="!locForm.get('locationFiltersEnabled').value" style="margin-top: 20px;">
    <mat-form-field>
      <mat-label>Filter type</mat-label>
      <mat-select formControlName="checkType">
        @for (s of locationCheckTypeTypes; track s) {
          <mat-option [value]="s.value">{{ s.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <app-campaign-location-filters #locationFilters [campaignId]="campaignId" [originalCampaignId]="originalCampaignId"></app-campaign-location-filters>
  </div>
</div>
